import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import Form from '../../components/Appraisal/form'
import { v3_my_appraisal_formData, v3_submit_appraisal_form } from '../../actions/v3/appraisal';
import { toast } from 'react-toastify';
import constant from '../../constant';
const Add = (props) => {

    const [data, setData] = useState(null);
    useEffect(() => {
        v3_my_appraisal_formData().then((res) => {
            if (res.status) {
                setData(res.result)
            }
        })
    }, [])

    const onSubmit = (payload) => {
        v3_submit_appraisal_form(payload)
            .then((res) => {
                if (res.status) {
                    toast.success("Appraisal submitted successfully!");
                    props.history.push(constant.Authedcomponent.submittedAppraisals.url)
                } else {
                    toast.error(res.error);
                }
            })
            .catch((error) => {
                console.error("Submission Error:", error);
                toast.error("Something went wrong. Please check your inputs or try again later.");
            });
    };

    return (
        <Layout title={'Appraisal Report - Site Manager & Inspector'}>
            <Form
                data={data}
                onSubmit={onSubmit}
            />
        </Layout>

    )
}

export default Add